export const environment = {
  production: true,
  HOST:'',
  BASE_URL: '/b2c/eshop',
  B2C_URL: '/b2c',
  ESHOP_URL: '/b2c/eshop',
  SAS_URL: '/b2c/sas',
  LINK_URL: '/b2c/addon',
  ECARE_URL: '/b2c',
  CMS_HOST: '',
  PREPHIRAL_UR: 'http://localhost',
  ATG: 'http://dx2716:20011/eshop',
  HOME: '',
  GTM: 'GTM-TSZ46Z',
  TRANSLATION_URL: '/b2c/labels.service?app=CHECKOUT&locale=',
  MAP_KEY: 'AIzaSyDGHGq1W76Xca8Q2YbMmlAu6LDpD3-UOL8',
};
